
import jQuery from 'jquery'
import moment from 'moment'
import numeral from 'numeral'
import SS from 'markojs-shared-state'
import { navigate } from 'marko-router5'
import Storage from 'all-localstorage'

String.prototype.toCapitalCase = function(){
  // Fonction de capitalisation du premier caractère d'un mot
  this.toLowerCase()

  const
  First = this.charAt(0),
  regex = new RegExp('^'+ First )

  return First.toUpperCase() + this.split( regex )[1]
}

/*--------------------------------------------------------------------------*/
// Global varaibles
window.UserAgent = null // Define after "init" request
window.OnbehalfOrigin = false

/*--------------------------------------------------------------------------*/
// Init JS plugins
window.$ =
window.jQuery = jQuery
window.navigate = navigate // To navigate routers by function call
window.uiStore = new Storage({ prefix: 'mpt-DDS33', encrypt: true })
window.Device = { browser: navigator.userAgent, platform: navigator.platform }

/*--------------------------------------------------------------------------*/
// Add to shared-state library an easy DX API
const 
shareState = SS(),
GState = shareState
GState.bind = shareState.bind
GState.unbind = shareState.unbind
GState.get = shareState.getState
GState.set = shareState.setState
GState.dirty = shareState.setStateDirty
GState.define = shareState.defineAPI

window.GState = GState

/*--------------------------------------------------------------------------*/
// Util functions
window.isDefaultDomain = () => {
  // Check whether the current domain is default: web.multipple.com
  return document.location.origin.includes( window.Defaults.domain )
}
window.onbehalfOf = origin => {
  const protocol = window.location.protocol
  window.OnbehalfOrigin = origin.includes( protocol ) ? origin : protocol +'//'+ origin
}
window.ellipsisText = ( text, nWords, words ) => {

  nWords = Number( nWords ) || 10
  words = text.split(/\s+/g)

  if( words.length <= nWords ) return text
  text = ''

  for( let o = 0; o < words.length; o++ ){
    if( o == nWords ) break
    text += ' '+ words[o]
  }

  return text +' ...'
}
window.formatAmount = ( amt, currency ) => {
  // precision = Number( precision ) || 2
  // amt = Number( amt ).toFixed( precision )
  amt = numeral( amt ).format('0,0.00')

  if( !currency ) return amt

  if( typeof currency == 'object' ){
    /*{
        code: "XOF"
        name: "CFA Franc BCEAO"
        plural: "CFA francs BCEAO"
        symbol: "CFA"
        symbol_native: "CFA"
      } */
    let cstr = currency.symbol_native || currency.symbol
      
    if( cstr ) amt = String( cstr ).length > 1 ? amt +' '+ cstr : cstr + amt
    else if( currency.id || currency.code ) {
      cstr = currency.id || currency.code
      const cnames = currency.name.split(/\s+/)

      // Match capital sign only
      if( cnames.length > 1 )
        for( let o = 0; o < cnames.length; o++ ){
          const matches = cnames[o].match(/[A-Z]+/)

          if( matches && matches.length && matches[0].length > 2 ){
            cstr = matches[0]
            break
          }
        }
      else cstr = cnames[0]

      amt += ' '+ cstr
    }
  }
  else amt = currency + amt

  return amt
}
window.formatDate = ( date, format ) => {

  const _date = date == 'now' ? moment() : moment( date )

  if( format == 'calendar' ) return _date.calendar()

  return _date.format( format )
}
window.currencySymbol = currency => {

  if( typeof currency !== 'object' ) return currency
  if( currency.symbol ) return currency.symbol

  let
  cstr = currency.id,
  cnames = currency.name.split(/\s+/)

  // Match capital sign only
  if( cnames.length > 1 )
    for( let o = 0; o < cnames.length; o++ ){
      const matches = cnames[o].match(/[A-Z]+/)

      if( matches.length && matches[0].length > 2 ){
        cstr = matches[0]
        break
      }
    }
  else cstr = cnames[0]

  return cstr
}
window.isEmpty = entry => {
  // Test empty array or object
  if( typeof entry !== 'object' ) return null

  return Array.isArray( entry ) ?
              !entry.length
              : Object[ Object.entries ? 'entries' : 'keys' ]( entry ).length === 0 && entry.constructor === Object
}
window.getFullname = profile => {
  return profile.first_name +' '+ profile.last_name
}
window.openTool = ( name, subject ) => {
  // Open aside tool from body
  GState.set('atool', name )
  uiStore.set('atool', name )

  /* TODO: Set the special subject of opening the tool or
    the current page criterias will be pick by default
  */



  GState.workspace.layout({ mode: 'auto' })
}
window.Obj2Params = ( obj, excludes ) => {

  return Object.entries( obj )
                .map( ([ key, value ]) => {
                  if( !Array.isArray( excludes ) || !excludes.includes( key ) )
                    return key +'='+ value
                }).join('&')
}
window.Params2Obj = ( str, excludes ) => {

  let obj = {},
      array = str.split('&')

  array.map( each => {
          let [ key, value ] = each.split('=')

          if( !Array.isArray( excludes ) || !excludes.includes( key ) )
            obj[ key ] = value
        })

  return obj
}
window.random = ( min, max ) => {
  // generate random number at a range
  return Math.floor( Math.random() * ( max - min + 1 )+( min + 1 ) )
}
window.getSelectedText = () => {

  let text = ''

  if( window.getSelection
      && window.getSelection().toString()
      && $(window.getSelection()).attr('type') != "Caret" ){

      text = window.getSelection().toString()
      return text
  }
  else if( document.getSelection
            && document.getSelection().toString()
            && $(document.getSelection()).attr('type') != "Caret" ){

      text = document.getSelection().toString()
      return text
  }
  else {
    let selection = document.selection && document.selection.createRange()

    if( !( typeof selection === "undefined" )
        && selection.text
        && selection.text.toString() ){

        text = selection.text
        return text
    }
  }

  return false
}
window.debugLog = ( ...args ) => {
  if( window.env == 'production' ) return
  console.log( ...args )
}
window.newObject = obj => { return typeof obj == 'object' && JSON.parse( JSON.stringify( obj ) ) }
window.deepAssign = ( obj1, obj2 ) => { return Object.assign( newObject( obj1 ), obj2 || {} ) }

window.corsProxy = ( url, type ) => {
  // Ignore wrapping same origin URL
  return new RegExp( location.origin ).test( url )
          || !/^http(s?):\/\//.test( url ) ?
                        /^@(.+)\//.test( url ) ? '/'+ url : url
                        : `/proxy?url=${encodeURIComponent( url )}&responseType=${type || 'blob'}`
}
window.base64ToBlob = ( str, name ) => {
  /**
   * Convert BASE64 to BLOB
   * @param base64Image Pass Base64 image data to convert into the BLOB
   */
  const
  parts = str.split(';base64,'), // Split into two parts
  imageType = parts[0].split(':')[1], // Hold the content type
  decodedData = window.atob( parts[1] ), // Decode Base64 string

  // Create UNIT8ARRAY of size same as row data length
  uInt8Array = new Uint8Array( decodedData.length )

  // Insert all character code into uInt8Array
  for( let i = 0; i < decodedData.length; ++i )
    uInt8Array[ i ] = decodedData.charCodeAt( i )

  // Return BLOB image after conversion
  return new Blob( [ uInt8Array ], { type: imageType, name: name || 'auto' } )
}
window.makePayment = invoice => {
  return new Promise( ( resolve, reject ) => {
    let managerName, payload
    const
    succeed = ( response, saleId ) => {
      resolve( response, saleId )
      window.Extensions.quit('MixPay')
    },
    failed = error => reject( new Error( error.message ) ),
    tenant = GState.get('tenant')
    
    switch( tenant && tenant.settings.paymentManager ){
      case 'MixPay':
      default: managerName = 'MixPay'
                payload = { action: 'pay', invoice, succeed, failed }
    }

    window.Extensions.run( managerName, payload )
  } )
}

/*--------------------------------------------------------------------------*/
// Global DOM Event Listeners
$.fn.extend({
  drop: function( fn ){ return fn ? this.bind( 'drop', fn ) : this.trigger('drop') },
  dragend: function( fn ){ return fn ? this.bind( 'dragend', fn ) : this.trigger('dragend') },
  dragstart: function( fn ){ return fn ? this.bind( 'dragstart', fn ) : this.trigger('dragstart') },
  dragover: function( fn ){ return fn ? this.bind( 'dragover', fn ) : this.trigger('dragover') },
  dragenter: function( fn ){ return fn ? this.bind( 'dragenter', fn ) : this.trigger('dragenter') },
  dragleave: function( fn ){ return fn ? this.bind( 'dragleave', fn ) : this.trigger('dragleave') }
} )

$(document)
.on( 'click', e => {
  // Disable active context-menu
  GState.set( 'activeCtxtMenu', null )
} )
.dragover( e => e.preventDefault() )

/*--------------------------------------------------------------------------*/